import React from "react";

import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./components/app/app";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <App />
        </HelmetProvider>
        ,
    </React.StrictMode>,
);
